import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo8 } from "../../../routes/Module8";
import Imagen1 from "../../../images/modulo8/votantes1.png";
import Imagen2 from "../../../images/modulo8/electores2.png";
import Imagen3 from "../../../images/modulo8/electores3.png";

import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo8/Actividad 7.mp3";

const Actividad8 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "1" },
    ans2: { value: "", valid: "", correctValue: "0" },
    ans3: { value: "", valid: "", correctValue: "1" },
    ans4: { value: "", valid: "", correctValue: "0" },
    ans5: { value: "", valid: "", correctValue: "0" },
    ans6: { value: "", valid: "", correctValue: "0" },
    ans7: { value: "", valid: "", correctValue: "1" },
    ans8: { value: "", valid: "", correctValue: "0" },
    ans9: { value: "", valid: "", correctValue: "0" },
    ans10: { value: "", valid: "", correctValue: "0" },
    ans11: { value: "", valid: "", correctValue: "0" },
    ans12: { value: "", valid: "", correctValue: "0" },
    ans13: { value: "", valid: "", correctValue: "1" },
    ans14: { value: "", valid: "", correctValue: "1" },
    ans15: { value: "", valid: "", correctValue: "0" },
    ans16: { value: "", valid: "", correctValue: "1" },
    ans17: { value: "", valid: "", correctValue: "1" },
    ans18: { value: "", valid: "", correctValue: "0" },
    ans19: { value: "", valid: "", correctValue: "1" },
    ans20: { value: "", valid: "", correctValue: "1" },
    ans21: { value: "", valid: "", correctValue: "1" },
    ans22: { value: "", valid: "", correctValue: "1" },
    ans23: { value: "", valid: "", correctValue: "1" },
    ans24: { value: "", valid: "", correctValue: "1" },
  });
  const infoUnidad = modulo8.content[0];
  const infoAct = modulo8.content[0].activities[6];
  const crumbs = [
    {
      title: modulo8.title,
      url: "/" + modulo8.url,
    },
    {
      title:
        modulo8.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo8.content[0].activities[7].name}`,
    linkNext: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[7].path}`,
    titlePrev: `${modulo8.content[0].activities[5].name}`,
    linkPrev: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo8.color,
    title: `${modulo8.title} - ${infoAct.name}`,
    name: modulo8.title,
  };
  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo8.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>
          Lee la historia con un compañero, compañera o familiar. Marca con un
          check los personajes que podrían votar en cada etapa.
        </li>
      </ul>

      <div className="row align-items-center mt-5">
        <div className="col-md-4 col-12">
          <Card>
            <div>Siglo XIX</div>
            <p>
              Durante casi todo el siglo XIX, votaban en el Perú todos los
              hombres mayores de 21 años. Los únicos que no votaban eran los
              africanos o descendientes de africanos por ser o haber sido
              esclavos. Las mujeres no votaban.
            </p>
          </Card>
        </div>
        <div className="col-md-8 col-12">
          <img src={Imagen1} alt="Electores" className="img-fluid w-100" />
          <div className="row text-center">
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans1.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans1.value === "1"}
                onChange={(event) => handleAnswers(event, "ans1")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans2.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans2.value === "1"}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans3.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans3.value === "1"}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans4.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans4.value === "1"}
                onChange={(event) => handleAnswers(event, "ans4")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans5.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans5.value === "1"}
                onChange={(event) => handleAnswers(event, "ans5")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans6.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans6.value === "1"}
                onChange={(event) => handleAnswers(event, "ans6")}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row align-items-center mt-5">
        <div className="col-md-4 col-12">
          <Card>
            <div>1896</div>
            <p>
              En 1896, a finales del siglo XIX, se dio una ley que decía que
              solo podían votar los hombres que sabían leer y escribir. Esto
              dejaba fuera a muchos indígenas y afroperuanos. Las mujeres
              seguían sin poder votar.
            </p>
          </Card>
        </div>
        <div className="col-md-8 col-12">
          <img src={Imagen1} alt="Electores" className="img-fluid w-100" />
          <div className="row text-center">
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans7.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans7.value === "1"}
                onChange={(event) => handleAnswers(event, "ans7")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans8.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans8.value === "1"}
                onChange={(event) => handleAnswers(event, "ans8")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans9.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans9.value === "1"}
                onChange={(event) => handleAnswers(event, "ans9")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans10.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans10.value === "1"}
                onChange={(event) => handleAnswers(event, "ans10")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans11.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans11.value === "1"}
                onChange={(event) => handleAnswers(event, "ans11")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans12.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans12.value === "1"}
                onChange={(event) => handleAnswers(event, "ans12")}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row align-items-center mt-5">
        <div className="col-md-4 col-12">
          <Card>
            <div>1956</div>
            <p>
              Las mujeres pueden votar por primera vez en las elecciones
              presidenciales de 1956. Los analfabetos siguen sin poder votar.
            </p>
          </Card>
        </div>
        <div className="col-md-8 col-xs-12">
          <img src={Imagen2} alt="Electores" className="img-fluid w-100" />
          <div className="row text-center">
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans13.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans13.value === "1"}
                onChange={(event) => handleAnswers(event, "ans13")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans14.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans14.value === "1"}
                onChange={(event) => handleAnswers(event, "ans14")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans15.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans15.value === "1"}
                onChange={(event) => handleAnswers(event, "ans15")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans16.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans16.value === "1"}
                onChange={(event) => handleAnswers(event, "ans16")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans17.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans17.value === "1"}
                onChange={(event) => handleAnswers(event, "ans17")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans18.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans18.value === "1"}
                onChange={(event) => handleAnswers(event, "ans18")}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row align-items-center mt-5">
        <div className="col-md-4 col-12">
          <Card>
            <div>1980</div>
            <p>
              Recién en 1980, los analfabetos pueden volver a votar en el Perú.
            </p>
          </Card>
        </div>
        <div className="col-md-8 col-xs-12">
          <img src={Imagen3} alt="Electores" className="img-fluid w-100" />
          <div className="row text-center">
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans19.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans19.value === "1"}
                onChange={(event) => handleAnswers(event, "ans19")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans20.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans20.value === "1"}
                onChange={(event) => handleAnswers(event, "ans20")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans21.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans21.value === "1"}
                onChange={(event) => handleAnswers(event, "ans21")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans22.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans22.value === "1"}
                onChange={(event) => handleAnswers(event, "ans22")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans23.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans23.value === "1"}
                onChange={(event) => handleAnswers(event, "ans23")}
              />
            </div>
            <div className="col-2">
              <input
                className={
                  "form-check-input mb-1 form-md " + answers.ans24.valid
                }
                type="checkbox"
                value="1"
                checked={answers.ans24.value === "1"}
                onChange={(event) => handleAnswers(event, "ans24")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo8.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea la indicación. Lean los textos y observen las imágenes. A partir
          del diálogo, revisen las respuestas: siglo XIX, todos los hombres;
          1896, solo hombres alfabetos; 1956, hombres y mujeres alfabetos; 1980,
          todos y todas.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
